import type { SendAlertErrorActionPayload } from './alert.slice.types';
import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';
import { ALERT_TYPE, type AlertState } from 'shared/interfaces/alert.interface';

const initialState: AlertState = {
  type: null,
  message: null,
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    sendAlertSuccessAction: (state, _action: PayloadAction<unknown>) => {
      state.type = ALERT_TYPE.SUCCESS;
    },
    sendAlertErrorAction: (
      state,
      action: PayloadAction<SendAlertErrorActionPayload>,
    ) => {
      const error = action.payload.error;

      state.type = ALERT_TYPE.DANGER;

      if (!error) {
        state.message = 'Unknown error';
      } else if (error instanceof Error) {
        // state.message = error.message || 'Unknown error';
      } else if (typeof error === 'string') {
        state.message = error;
      } else {
        state.message = 'An unexpected error occurred';
      }
    },
    clearAlertsAction: (state) => {
      state.type = null;
      state.message = null;
    },
  },
});

export const {
  clearAlertsAction,
  sendAlertErrorAction,
  sendAlertSuccessAction,
} = alertSlice.actions;

export const alertReducer = alertSlice.reducer;
